import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import "./CaseWorkers.css";
// import NewChatIcon from "../../../assets/NewChatIcon";
import UserChatBubble2 from "@/Components/Forms/FirmUserBtn2";

import ChatSendingPopup from "../../Forms/common/ChatSendingPopup";
import { addClickRecord } from "../../../Utils/helper";
import CallsIcon from "../../../assets/call-icon";
import NewPhoneIcon from "../../../assets/NewPhoneIcon";
import AttachUserModal from "../AttachUserModal";

import { OtherFirmTeams } from "./OtherFirmTeams";

export const WorkersOnCase = ({ selectedRoleIds }) => {
  const [chatData, setChatData] = useState(null);
  const [chatModal, setChatModal] = useState(false);
  const openChatModel = (event, data) => {
    event?.stopPropagation();
    setChatData(data);
    setChatModal(!chatModal);
  };
  const userOnlineStatus = useSelector((state) => state.chat2.userOnlineStatus);
  const page_id_click_record = useSelector(
    (state) => state.page_id_click_record.page_id_click_record
  );
  const currentCase = useSelector((state) => state.caseData?.current);
  const caseSummary = useSelector((state) => state.caseData?.summary);
  const [firmUsers, setFirmUsers] = useState([]);
  const [isCaseWorkerModalOpen, setIsCaseWorkerModalOpen] = useState(false);
  const canManagePositions = caseSummary?.team_scope?.can_manage_positions === true;
  const openModal = () => {
    if (canManagePositions) setIsCaseWorkerModalOpen(true);
  };
  useEffect(() => {
    if (currentCase && caseSummary && caseSummary?.workers) {
      setFirmUsers([
        {
          firm_user: caseSummary?.firm_user1,
          user_type: caseSummary?.workers[0],
        },
        {
          firm_user: caseSummary?.firm_user2,
          user_type: caseSummary?.workers[1],
        },
        {
          firm_user: caseSummary?.firm_user3,
          user_type: caseSummary?.workers[2],
        },
        {
          firm_user: caseSummary?.firm_user4,
          user_type: caseSummary?.workers[3],
        },
        {
          firm_user: caseSummary?.firm_user5,
          user_type: caseSummary?.workers[4],
        },
        {
          firm_user: caseSummary?.firm_user6,
          user_type: caseSummary?.workers[5],
        },
      ]);
    }
  }, [currentCase, caseSummary]);
  const adjustCaseDetailsWidths = () => {
    const leftColumns = document.querySelectorAll(".person-index-name");

    // Clear stale synchronized widths before measuring updated case workers.
    leftColumns.forEach((column) => {
      column.style.width = "auto";
    });

    let maxLeftWidth = 0;

    // Calculate maximum width for left and right columns
    leftColumns.forEach((column) => {
      const width = column.scrollWidth;
      maxLeftWidth = Math.max(maxLeftWidth, width);
    });

    leftColumns.forEach((column) => {
      column.style.width = `${maxLeftWidth}px`;
    });
  };

  useEffect(() => {
    const animationFrame = window.requestAnimationFrame(adjustCaseDetailsWidths);
    window.addEventListener("resize", adjustCaseDetailsWidths);
    return () => {
      window.cancelAnimationFrame(animationFrame);
      window.removeEventListener("resize", adjustCaseDetailsWidths);
    };
  }, [caseSummary, firmUsers]);

  return (
    <>
      {firmUsers && (
        <div className=" m-b-5 p-l-0">
          <div className="position-relative overflow-hidden">
            <div className="expandable-section">
              <div className="p-l-5 height-25 menu-bar-style">
                <h4 className="client-contact-title text-center d-flex justify-content-center align-items-center h-100">
                  {caseSummary && caseSummary?.staff_team
                    ? `${caseSummary.staff_team?.team_name.toUpperCase()} TEAM — ASSIGNED TO CASE`
                    : "CASE WORKERS ASSIGNED TO CASE"}
                </h4>
              </div>

              <div
                className="d-md-flex d-xl-flex flex-md-column w-100 flex-xl-row f-gap-05"
                // style={{
                //   height: "80px",
                // }}
              >
                <div
                  className="table-responsive d-flex-1 table--no-card rounded-0 border-0 position-relative"
                  style={{
                    height: "75px",
                    overflow: "hidden",
                  }}
                >
                  <table className="table  table-borderless table-striped table-workers table-workers-1st has-height-25 has-table-sub-panel ">
                    <tbody
                      //   caseSummary && caseSummary?.p_add_firm_user
                      //     ? "#attach-user-modal"
                      //     : "#add_firm_user"
                      // }
                      onClick={() => {
                        openModal();
                      }}
                    >
                      {firmUsers &&
                        firmUsers.length > 0 &&
                        firmUsers.slice(0, 3).map((d, index) => (
                          <tr
                            onClick={() => {
                              // e.stopPropagation();
                              addClickRecord(999, page_id_click_record);
                            }}
                            key={index}
                          >
                            <td
                              style={{
                                padding: "0 10px",
                                height: "25px",
                                width: "25px",
                                maxWidth: "25px",
                                minWidth: "25px",
                              }}
                            >
                              {selectedRoleIds?.has(d?.user_type?.id) ? (
                                <span className="d-flex align-items-center justify-content-center">
                                  <NewPhoneIcon />
                                </span>
                              ) : (
                                <span className="d-flex align-items-center justify-content-center">
                                  <CallsIcon colorCode="var(--primary-25)" />
                                </span>
                              )}
                            </td>
                            <td
                              style={{
                                height: "25px",
                                padding: "10px",
                                width: "33.3%",
                                fontWeight: "600",
                              }}
                              className="d-flex-inline color-black align-items-center"
                            >
                              {" "}
                              {d.user_type?.name}
                            </td>
                            {d.firm_user &&
                            d.firm_user.for_firmsetting &&
                            d.firm_user.for_firmsetting.assign_firm_user ? (
                              d.user_type1 &&
                              d.firm_user &&
                              d.firm_user.user.id === d.user_type.id ? (
                                <td
                                  style={{
                                    height: "25px",
                                    padding: "10px",
                                    width: "33.3%",
                                  }}
                                  className="d-flex-inline d-flex justify-content-center align-items-center color-black p-3"
                                  id="case-user-1"
                                >
                                  <UserChatBubble2
                                    data={d}
                                    first_name={d.firm_user?.user?.first_name ?? ""}
                                    last_name={d.firm_user?.user?.last_name ?? ""}
                                    profilePic={d.firm_user?.profile_pic_29p ?? ""}
                                    onClick={(e) => {
                                      addClickRecord(999, page_id_click_record);
                                      openChatModel(e, d);
                                    }}
                                    isActive={
                                      userOnlineStatus?.[d?.firm_user?.user?.id]?.isOnline ?? false
                                    }
                                    is_active={d.firm_user?.user?.is_active}
                                    width={19}
                                  />
                                </td>
                              ) : (
                                <>
                                  <td
                                    style={{
                                      height: "25px",
                                      padding: "10px",
                                      width: "33.3%",
                                    }}
                                    className="d-flex-inline text-black d-flex justify-content-center align-items-center"
                                  >
                                    <UserChatBubble2
                                      data={d}
                                      first_name={d.firm_user?.user?.first_name ?? ""}
                                      last_name={d.firm_user?.user?.last_name ?? ""}
                                      profilePic={d.firm_user?.profile_pic_29p ?? ""}
                                      onClick={(e) => {
                                        addClickRecord(999, page_id_click_record);
                                        openChatModel(e, d);
                                      }}
                                      isActive={
                                        userOnlineStatus?.[d?.firm_user?.user?.id]?.isOnline ??
                                        false
                                      }
                                      is_active={d.firm_user?.user?.is_active}
                                      width={19}
                                    />
                                  </td>
                                </>
                              )
                            ) : d.firm_user && d.firm_user.profile_pic_29p ? (
                              <>
                                <td
                                  style={{
                                    height: "25px",
                                    padding: "10px",
                                    width: "33.3%",
                                  }}
                                  className="d-flex-inline d-flex justify-content-center align-items-center color-black p-3"
                                >
                                  <UserChatBubble2
                                    data={d}
                                    first_name={d.firm_user?.user?.first_name ?? ""}
                                    last_name={d.firm_user?.user?.last_name ?? ""}
                                    profilePic={d.firm_user?.profile_pic_29p ?? ""}
                                    onClick={(e) => {
                                      addClickRecord(999, page_id_click_record);
                                      openChatModel(e, d);
                                    }}
                                    isActive={
                                      userOnlineStatus?.[d?.firm_user?.user?.id]?.isOnline ?? false
                                    }
                                    is_active={d.firm_user?.user?.is_active}
                                    width={19}
                                  />
                                </td>
                              </>
                            ) : (
                              <td
                                style={{
                                  height: "25px",
                                  padding: "10px",
                                  width: "33.3%",
                                  fontWeight: "600",
                                }}
                                className="d-flex-inline text-black d-flex align-items-center justify-content-center"
                              >
                                <UserChatBubble2
                                  data={d}
                                  first_name={d.firm_user?.user?.first_name ?? ""}
                                  last_name={d.firm_user?.user?.last_name ?? ""}
                                  profilePic={d.firm_user?.user?.profile_pic_29p ?? ""}
                                  onClick={(e) => {
                                    addClickRecord(999, page_id_click_record);
                                    openChatModel(e, d);
                                  }}
                                  isActive={
                                    userOnlineStatus?.[d?.firm_user?.user?.id]?.isOnline ?? false
                                  }
                                  is_active={d.firm_user?.user?.is_active}
                                  width={19}
                                />
                              </td>
                            )}
                            <td
                              style={{
                                height: "25px",
                                width: "33.3%",
                                padding: "10px 5px 10px 0",
                                textAlign: "right",
                                display: "flex",
                                justifyContent: "flex-end",
                                fontWeight: "600",
                              }}
                              className="d-flex-inline text-end align-items-center caseWorkerLastAccessedDate"
                              id="case-clickdate-1"
                            >
                              <span className="p-r-5"> {d?.user_type?.click_record_date}</span>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
                <div
                  className="table-responsive d-flex-1 table--no-card rounded-0 border-0"
                  style={{
                    height: "75px",
                    overflow: "hidden",
                  }}
                >
                  <table className="table table-borderless table-striped table-workers table-workers-2nd has-height-25 has-table-sub-panel ">
                    <tbody
                      onClick={() => {
                        openModal();
                      }}
                      //   caseSummary && caseSummary?.p_add_firm_user
                      //     ? "#attach-user-modal"
                      //     : "#add_firm_user"
                      // }
                    >
                      {firmUsers &&
                        firmUsers.length > 0 &&
                        firmUsers.slice(3).map((d, index) => (
                          <tr
                            onClick={() => {
                              // e.stopPropagation();
                              addClickRecord(999, page_id_click_record);
                            }}
                            key={index}
                          >
                            <td
                              style={{
                                height: "25px",
                                width: "25px",
                                maxWidth: "25px",
                                minWidth: "25px",
                              }}
                            >
                              {selectedRoleIds?.has(d?.user_type?.id) ? (
                                <span className="d-flex align-items-center justify-content-center">
                                  <NewPhoneIcon />
                                </span>
                              ) : (
                                <span className="d-flex align-items-center justify-content-center">
                                  <CallsIcon colorCode="var(--primary-25)" />
                                </span>
                              )}
                            </td>
                            <td
                              style={{
                                height: "25px",
                                padding: "10px",
                                width: "33.3%",
                                fontWeight: "600",
                              }}
                              className="d-flex-inline color-black align-items-center"
                            >
                              {" "}
                              {d.user_type?.name}
                            </td>
                            {d.firm_user &&
                            d.firm_user.for_firmsetting &&
                            d.firm_user.for_firmsetting.assign_firm_user ? (
                              d.user_type1 &&
                              d.firm_user &&
                              d.firm_user.user.id === d.user_type.id ? (
                                <td
                                  style={{
                                    height: "25px",
                                    padding: "10px",
                                    width: "33.3%",
                                  }}
                                  className="d-flex-inline d-flex justify-content-center align-items-center color-black p-3"
                                  id="case-user-1"
                                >
                                  <UserChatBubble2
                                    data={d}
                                    first_name={d.firm_user?.user?.first_name ?? ""}
                                    last_name={d.firm_user?.user?.last_name ?? ""}
                                    profilePic={d.firm_user?.profile_pic_29p ?? ""}
                                    onClick={(e) => {
                                      addClickRecord(999, page_id_click_record);
                                      openChatModel(e, d);
                                    }}
                                    isActive={
                                      userOnlineStatus?.[d?.firm_user?.user?.id]?.isOnline ?? false
                                    }
                                    is_active={d.firm_user?.user?.is_active}
                                    width={19}
                                  />
                                </td>
                              ) : (
                                <>
                                  <td
                                    style={{
                                      height: "25px",
                                      padding: "10px",
                                      width: "33.3%",
                                    }}
                                    className="d-flex-inline text-black d-flex justify-content-center align-items-center"
                                  >
                                    <UserChatBubble2
                                      data={d}
                                      first_name={d.firm_user?.user?.first_name ?? ""}
                                      last_name={d.firm_user?.user?.last_name ?? ""}
                                      profilePic={d.firm_user?.profile_pic_29p ?? ""}
                                      onClick={(e) => {
                                        addClickRecord(999, page_id_click_record);
                                        openChatModel(e, d);
                                      }}
                                      isActive={
                                        userOnlineStatus?.[d?.firm_user?.user?.id]?.isOnline ??
                                        false
                                      }
                                      is_active={d.firm_user?.user?.is_active}
                                      width={19}
                                    />
                                  </td>
                                </>
                              )
                            ) : d.firm_user && d.firm_user.profile_pic_29p ? (
                              <>
                                <td
                                  style={{
                                    height: "25px",
                                    padding: "10px",
                                    width: "33.3%",
                                  }}
                                  className="d-flex-inline d-flex justify-content-center align-items-center color-black p-3"
                                >
                                  <UserChatBubble2
                                    data={d}
                                    first_name={d.firm_user?.user?.first_name ?? ""}
                                    last_name={d.firm_user?.user?.last_name ?? ""}
                                    profilePic={d.firm_user?.profile_pic_29p ?? ""}
                                    onClick={(e) => {
                                      addClickRecord(999, page_id_click_record);
                                      openChatModel(e, d);
                                    }}
                                    isActive={
                                      userOnlineStatus?.[d?.firm_user?.user?.id]?.isOnline ?? false
                                    }
                                    is_active={d.firm_user?.user?.is_active}
                                    width={19}
                                  />
                                </td>
                              </>
                            ) : (
                              <td
                                style={{
                                  height: "25px",
                                  padding: "10px",
                                  width: "33.3%",
                                  fontWeight: "600",
                                }}
                                className="d-flex-inline text-black d-flex align-items-center justify-content-center"
                              >
                                <UserChatBubble2
                                  data={d}
                                  first_name={d.firm_user?.user?.first_name ?? ""}
                                  last_name={d.firm_user?.user?.last_name ?? ""}
                                  profilePic={d.firm_user?.profile_pic_29p ?? ""}
                                  onClick={(e) => {
                                    addClickRecord(999, page_id_click_record);
                                    openChatModel(e, d);
                                  }}
                                  isActive={
                                    userOnlineStatus?.[d?.firm_user?.user?.id]?.isOnline ?? false
                                  }
                                  is_active={d.firm_user?.user?.is_active}
                                  width={19}
                                />
                              </td>
                            )}
                            <td
                              style={{
                                height: "25px",
                                width: "33.3%",
                                padding: "10px 5px 10px 0",
                                textAlign: "right",
                                display: "flex",
                                justifyContent: "flex-end",
                                fontWeight: "600",
                              }}
                              className="d-flex-inline text-end align-items-center caseWorkerLastAccessedDate"
                              id="case-clickdate-1"
                            >
                              <span className="p-r-5"> {d?.user_type?.click_record_date}</span>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <OtherFirmTeams />
      {isCaseWorkerModalOpen && (
        <AttachUserModal
          isModalOpen={isCaseWorkerModalOpen}
          closeModal={() => setIsCaseWorkerModalOpen(false)}
        />
      )}
      {chatModal && (
        <ChatSendingPopup
          data={chatData}
          show={chatModal}
          handleClose={() => {
            addClickRecord(999, page_id_click_record);
            setChatModal(false);
          }}
          first_name={chatData?.firm_user?.user?.first_name}
          last_name={chatData?.firm_user?.user?.last_name}
          userId={chatData?.firm_user?.user?.id}
          is_active={chatData?.firm_user?.user?.is_active}
          profilePic={chatData?.firm_user?.user?.profile_pic_29p ?? ""}
        />
      )}
    </>
  );
};
